<template>
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8004 0.800781H1.20039C0.988217 0.800781 0.784734 0.885067 0.634705 1.0351C0.484676 1.18512 0.400391 1.38861 0.400391 1.60078V14.4008C0.400391 14.613 0.484676 14.8164 0.634705 14.9665C0.784734 15.1165 0.988217 15.2008 1.20039 15.2008H10.8004C11.0126 15.2008 11.216 15.1165 11.3661 14.9665C11.5161 14.8164 11.6004 14.613 11.6004 14.4008V1.60078C11.6004 1.38861 11.5161 1.18512 11.3661 1.0351C11.216 0.885067 11.0126 0.800781 10.8004 0.800781ZM8.40039 12.0008H3.60039V10.4008H8.40039V12.0008ZM8.40039 8.80078H3.60039V7.20078H8.40039V8.80078ZM8.40039 5.60078H3.60039V4.00078H8.40039V5.60078Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Templates',
};
</script>
